<form [formGroup]="form">
  <div class="form-row">
    <mat-radio-group formControlName="terminationCause" (change)="terminationCauseChanged($event.value)">
      @for (cause of terminationCauses; track cause) {
        <mat-radio-button [value]="cause.entityId">{{ cause.text }}</mat-radio-button>
      }
      <mat-radio-button [value]="terminationCauseOtherName">{{ this.terminationCauseOtherName }}</mat-radio-button>
    </mat-radio-group>
  </div>
  <div class="form-row">
    <mat-form-field appearance="outline">
      <mat-label>Anden årsag</mat-label>
      <input matInput formControlName="terminationCauseOther" />
    </mat-form-field>
  </div>
</form>
